import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiClock, FiAlertTriangle } = FiIcons;

const InactivityWarningModal = ({ isOpen, timeRemaining, onExtend, onLogout }) => {
  const minutes = Math.floor(timeRemaining / 60);
  const seconds = timeRemaining % 60;

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
            onClick={onExtend}
          >
            {/* Modal */}
            <motion.div
              initial={{ opacity: 0, scale: 0.95, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.95, y: 20 }}
              onClick={(e) => e.stopPropagation()}
              className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden"
            >
              {/* Header */}
              <div className="bg-gradient-to-r from-orange-500 to-red-500 px-6 py-4">
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                    <SafeIcon icon={FiAlertTriangle} className="text-2xl text-white" />
                  </div>
                  <div>
                    <h2 className="text-xl font-bold text-white">Inactivity Warning</h2>
                    <p className="text-orange-100 text-sm">You will be logged out soon</p>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="text-center mb-6">
                  <div className="inline-flex items-center justify-center w-20 h-20 bg-orange-100 rounded-full mb-4">
                    <SafeIcon icon={FiClock} className="text-4xl text-orange-600" />
                  </div>
                  <p className="text-gray-700 text-lg mb-2">
                    You've been inactive for a while
                  </p>
                  <p className="text-gray-600 text-sm">
                    For your security, you'll be automatically logged out in:
                  </p>
                  <div className="mt-4 text-5xl font-bold text-orange-600 font-mono">
                    {minutes}:{seconds.toString().padStart(2, '0')}
                  </div>
                </div>

                {/* Actions */}
                <div className="space-y-3">
                  <button
                    onClick={onExtend}
                    className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-purple-700 transition-all flex items-center justify-center space-x-2"
                  >
                    <SafeIcon icon={FiClock} />
                    <span>I Need More Time (+15 minutes)</span>
                  </button>
                  <button
                    onClick={onLogout}
                    className="w-full bg-gray-100 text-gray-700 py-3 rounded-lg font-semibold hover:bg-gray-200 transition-all"
                  >
                    Logout Now
                  </button>
                </div>

                <p className="text-xs text-gray-500 text-center mt-4">
                  Any activity will also reset the timer
                </p>
              </div>
            </motion.div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default InactivityWarningModal;
